module.exports = __webpack_public_path__ + "img/building2.5902db29.jpg";